import { useEffect, useState } from "react";

const navLinks = [
  { href: "#schedule", label: "新番时间表" },
  { href: "#recommend", label: "追番推荐" },
  { href: "#updates", label: "动画更新" },
  { href: "#classics", label: "经典回顾" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-[0_4px_24px_rgba(0,0,0,0.06)] backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              scrolled ? "text-primary-700" : "text-background-50"
            }`}
          >
            51动漫网
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  : "text-background-100/90 hover:bg-background-50/20 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#updates"
            className="rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
          >
            <i className="ri-notification-3-line mr-1"></i>追番不迷路
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-xl md:hidden ${
            scrolled ? "bg-background-200 text-foreground-800" : "bg-background-50/20 text-background-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="mx-4 mb-4 rounded-2xl bg-background-50 p-3 shadow-lg md:hidden">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}